export interface PasswordCheck {
  id: 'length' | 'lower' | 'upper' | 'number' | 'symbol';
  label: string;
  met: boolean;
}

/** Mirrors the default Cognito password policy (8+ chars, lower, upper, number, symbol). */
export function passwordChecks(pw: string): PasswordCheck[] {
  return [
    { id: 'length', label: 'At least 8 characters', met: pw.length >= 8 },
    { id: 'lower', label: 'A lowercase letter', met: /[a-z]/.test(pw) },
    { id: 'upper', label: 'An uppercase letter', met: /[A-Z]/.test(pw) },
    { id: 'number', label: 'A number', met: /\d/.test(pw) },
    { id: 'symbol', label: 'A symbol', met: /[^A-Za-z0-9\s]/.test(pw) },
  ];
}

export function passwordScore(pw: string): 0 | 1 | 2 | 3 | 4 {
  const met = passwordChecks(pw).filter((c) => c.met).length;
  if (!pw) return 0;
  if (met <= 2) return 1;
  if (met === 3) return 2;
  if (met === 4) return 3;
  return pw.length >= 12 ? 4 : 3;
}

export function isPasswordValid(pw: string): boolean {
  return passwordChecks(pw).every((c) => c.met);
}
